import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { NewItemNumberPageRoutingModule } from './new-booking-number-routing.module';

import { NewBookingNumberPageComponent } from './new-booking-number.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NewItemNumberPageRoutingModule
  ],
  declarations: [NewBookingNumberPageComponent]
})
export class NewBookingNumberPageModule {}
